<template>
    <div id="profile-heading-container" class="shadow-reg p-3 row mb-6">
        <div class="col-auto image-container">
            <!-- <avatar-badge :src="displayImage" update-event="display-image-updated" :raised="false" :size="160"></avatar-badge> -->
            <avatar-uploader cardless v-model="profileImage" :raised="false" :size="{width:160, height:160}" @change="updateDisplayImage"></avatar-uploader>
        </div>
        <div id="profile-heading" class="col">
            <h2 class="display-4 montserrat-bold mb-0" v-text="user.fullname"></h2>
            <div class="mt--2 heading-small" v-text="displayedAddress"></div>
            <div class="mt-2 heading-small">
                Available points:
                <h2 class="mt--2 display-5 montserrat-bold mb-0" v-text="availablePoints"></h2>
            </div>
            
            <!-- <div v-if="showProfileLink" class="mt-2">
                <router-link to="/user/profile" v-slot="{ href, navigate }">
                    <a :href="href" @click="navigate" class="btn bg-secondary text-dark shadow-reg mt-2">
                        <i class="fa fa-eye mr-2"></i> View Profile
                    </a>
                </router-link>
            </div> -->
        </div>
    </div>
</template>
<script>
import { patch, route } from "@utils/network";
export default {
    name: "CustomerHeading",

    computed: {
        user() {
            return this.customer || {};
        },
        displayedAddress() {
            return this.user.address ? this.user.address.display_name : "";
        },
        displayImage() {
            return this.user.display_image || "/images/placeholders/avatar.jpg";
        },
        availablePoints() {
            return parseFloat(this.user.points || 0).toFixed(2);
        }
    },

    data: () => ({
        profileImage: null,
    }),

    methods: {
        updateDisplayImage(image) {
            this.profileImage = image;
        },

        updateDisplayImage(payload) {
            patch(route("users/:id/display-image", { id: this.user.id }), {
                data: { path: this.profileImage }
            })
                .then(response => this.updatedDisplayImage(response))
                .catch(error => this.updateDisplayImageFailed(error));
        },

        updatedDisplayImage(response) {
            this.promptSuccess(response.data.message);
            bus.$emit("display-image-updated", { path: response.data.result.path })
        },
        
        updateDisplayImageFailed(error) {
            console.log(error);
            this.promptErrors(error.response.data.message);
        },
    },

    watch: {
        displayImage(newValue) {
            this.profileImage = newValue;
        }
    },

    props: {
        customer: [Object],
        showProfileLink: [Boolean],
    },
}
</script>
<style lang="css" scoped>
    #profile-heading-container {
        border-radius: 6px;
        background-color: white;
    }
    #profile-heading-container .image-container {
        padding: 0px 15px 0px;
    }
    #profile-heading {
        padding: 0px 19px 0px;
    }
</style>